var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-tab account-adjust-container" },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "90px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "会员账号" } },
            [
              _c("el-input", {
                staticClass: "input-small",
                attrs: { disabled: "" },
                model: {
                  value: _vm.memberAccount,
                  callback: function ($$v) {
                    _vm.memberAccount = $$v
                  },
                  expression: "memberAccount",
                },
              }),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "钱包余额" } }, [
            _c(
              "div",
              { staticClass: "wallet-balance-row" },
              [
                _c("el-input", {
                  staticClass: "input-small",
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.walletBalanceDisplay,
                    callback: function ($$v) {
                      _vm.walletBalanceDisplay = $$v
                    },
                    expression: "walletBalanceDisplay",
                  },
                }),
                _c("el-button", {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-refresh",
                    circle: "",
                    size: "small",
                    loading: _vm.balanceLoading,
                  },
                  on: { click: _vm.refreshWalletBalance },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "调整类型", prop: "change_type" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.change_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "change_type", $$v)
                    },
                    expression: "form.change_type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("系统调整")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("输赢调整")]),
                ],
                1
              ),
              _c("div", { staticClass: "form-tip" }, [
                _vm._v(
                  "系统调整上下分不影响代理佣金计算 / 输赢调整则会影响代理佣金计算"
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "调整方式", prop: "adjust_method" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.adjust_method,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "adjust_method", $$v)
                    },
                    expression: "form.adjust_method",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "up" } }, [_vm._v("上分")]),
                  _c("el-radio", { attrs: { label: "down" } }, [
                    _vm._v("下分"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.form.adjust_method === "up"
            ? [
                _c(
                  "el-form-item",
                  { attrs: { label: "打码限制", prop: "need_lock" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.need_lock,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "need_lock", $$v)
                          },
                          expression: "form.need_lock",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v("无需打码限制"),
                        ]),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("需要打码限制"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.need_lock === 1,
                        expression: "form.need_lock === 1",
                      },
                    ],
                    attrs: { label: "打码倍数", prop: "multiple" },
                  },
                  [
                    _c("el-input-number", {
                      staticClass: "input-small",
                      attrs: { min: 1, controls: false, placeholder: "正整数" },
                      model: {
                        value: _vm.form.multiple,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "multiple", $$v)
                        },
                        expression: "form.multiple",
                      },
                    }),
                    _c("span", { staticClass: "suffix" }, [_vm._v("倍")]),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "调整金额", prop: "gold_yuan" } },
            [
              _c("el-input-number", {
                staticClass: "input-small",
                attrs: {
                  precision: 2,
                  min: 0,
                  controls: false,
                  placeholder: "最多两位小数",
                },
                model: {
                  value: _vm.form.gold_yuan,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "gold_yuan", $$v)
                  },
                  expression: "form.gold_yuan",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "desc" } },
            [
              _c("el-input", {
                staticClass: "textarea-small",
                attrs: {
                  type: "textarea",
                  rows: 3,
                  maxlength: "100",
                  "show-word-limit": "",
                  placeholder: "不超过100字",
                },
                model: {
                  value: _vm.form.desc,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "desc", $$v)
                  },
                  expression: "form.desc",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "上传图片", prop: "image_url" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    action: "#",
                    "show-file-list": false,
                    "on-change": _vm.handleImageChange,
                    "before-upload": _vm.beforeUpload,
                    "auto-upload": false,
                  },
                },
                [
                  _vm.form.image_url
                    ? _c("el-image", {
                        staticClass: "upload-preview",
                        attrs: { src: _vm.form.image_url, fit: "cover" },
                      })
                    : _c("div", { staticClass: "upload-placeholder" }, [
                        _c("i", { staticClass: "el-icon-plus" }),
                        _c("span", [_vm._v("上传图片")]),
                      ]),
                ],
                1
              ),
              _c("div", { staticClass: "upload-tip" }, [
                _vm._v("支持 jpg、jpeg、png，不超过 5M"),
              ]),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.submitLoading,
                  },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }